module.exports = "https://static.energy5.com/_next/static/images/percent80-e420cbf8f3998e7651277f3bfad2673b.png";